module.exports = __webpack_public_path__ + "img/fail.1794d860.png";